export default class IntersectionObject {
    constructor($dom,type){
        this.$dom = $dom;
        this.type = type;
        //this.eventEmitter = new EventEmitter();
    }

    observe(){

        let $children = this.$dom.find(".ef-scroll-in");
        $children.removeClass("ef-scroll-in").addClass("ef-anim-in");
        this.$dom.removeClass("ef-scroll").addClass("ef-anim-in");

        /*setTimeout(()=>{
            this.$dom
            .removeClass("transition-shutter--l")
            .removeClass("transition-box-content")

            .removeClass("transition-y")
            .removeClass("transition-fade")
            .removeClass("ef-anim-in");

            $children
            .removeClass("transition-shutter--l")
            .removeClass("transition-box-content")

            .removeClass("transition-y")
            .removeClass("transition-fade")
            .removeClass("ef-anim-in");
        },1500)*/
        //this.eventEmitter.emit("observe");

    }
}


// WEBPACK FOOTER //
// ./src/scripts/effects/intersection/IntersectionObject.js